<div class="container rounded">
    <div class="row">
        <section class="col-12 centrar banner">
            <h5 class="letra">Selecciona la cantidad de Tickets que deseas comprar</h5>
            <hr class="aaaa mb-1">
            <h5 *ngIf="cantidadDisponibles<=12 && this.cantidadPalcosDisponibles==null" >Quedan {{cantidadDisponibles}} disponibles en esta localidad</h5>
            <h5 *ngIf="this.cantidadPalcosDisponibles">Este palco tiene {{cantidadPalcosDisponibles}} boletas disponibles</h5>
        </section>

        <div class="botones-container">
            <div>
                <section class="col-12 centrar mt-3">
                    <button class="btnA" (click)="menos()">-</button> <strong
                        class="cantidad mx-2">{{cantidadTickets}}</strong>
                         <button class="btnA"
                        (click)="mas()">+</button>
                </section>
                <section class="col-12 centrar mt-3 mb-3">
                    <button class="botonNo" mat-button mat-dialog-close (click)="cerrar()">Cancelar</button>
                    <button class="botonLogin" mat-button mat-dialog-close (click)="siguiente()">Siguiente</button>
                </section>
            </div>

            <div class="container-fluid contendor-spinner2" *ngIf="cargando">
                <div class="spinner"></div>
            </div>
        </div>



    </div>
</div>
